import React from 'react';
import './App.css';
import Content from './component/content'
import 'antd/dist/antd.css'

function App() {
  return (
    <Content/>
  );
}

export default App;
